import PropTypes from 'prop-types';
import React from 'react';
import { RECURRING_FREQUENCIES } from '../constants';

const SelectFrequency = ({ value, onChange, disabled }) => (
  <select
    className="c-select"
    value={value}
    onChange={onChange}
    disabled={disabled}
    data-automation-id="select:frequency"
  >
    <option key={-1} value={-1} />
    { RECURRING_FREQUENCIES.map(freq => (
      <option key={freq.value} value={freq.value}>{ freq.label }</option>
    )) }
  </select>
);
SelectFrequency.propTypes = {
  value: PropTypes.number,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};
SelectFrequency.defaultProps = {
  value: -1,
  disabled: false,
  onChange: () => null,
};

export default SelectFrequency;
